import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat',
})
export class PhoneFormatPipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (!value) return '';

    // Remove the country code (+49) but keep the leading '0'
    let phone = value.replace(/^\+49/, '0');

    // Format as 0405 555 18 111
    return phone.replace(/^(\d{4})(\d{3})(\d{2})(\d{3})$/, '$1 $2 $3 $4');
  }
}
